import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {useAppSelector} from '../../../../helpers/reduxHelpers';
import {ApiTokenModel} from '../../../../models/api/apiTokenModel';
import {getIsSettingsTokensLoading} from '../../../../store/panels/settings/settingsPanelSelectors';
import {SettingsDevelopersDeleteTokenDialog} from '../../dialog/settingsDevelopersDeleteTokenDialog';

/*
 * Props.
 */

interface SettingsDevelopersHeaderTokenActionProps {
  token?: ApiTokenModel;
}

/*
 * Component.
 */

export const SettingsDevelopersHeaderTokenAction: FC<SettingsDevelopersHeaderTokenActionProps> = (props) => {
  const {token} = props;
  const [isShowingDeleteDialog, setIsShowingDeleteDialog] = useState(false);
  const isTokensLoading = useAppSelector(getIsSettingsTokensLoading);

  // Do not render actions when loading or when we do not have a token.
  if (isTokensLoading || !token) {
    return null;
  }
  return (
    <>
      <Button variant={ButtonVariantsEnum.SECONDARY_DANGER} onClick={() => setIsShowingDeleteDialog(true)}>
        <Trans id="settings-developers-delete-token-action-button">Delete</Trans>
      </Button>
      {isShowingDeleteDialog && (
        <SettingsDevelopersDeleteTokenDialog
          onRequestClose={() => setIsShowingDeleteDialog(false)}
          token={token}
        />
      )}
    </>
  );
};
